import React, { Component } from 'react';
import { Modal, Loading } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { TableDefault } from '../../../../components';
import { PREPARACAO, ENTREGUE, PRONTAENTREGA, DEVOLVIDO } from '../../../../config/StatusRequest';
import { pathDmService } from '../../../../services/Api';

class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      pageSize: 100,
      totalItems: 0,
      typeCleark: 2,
      type: null,
      orderBy: 'DataSolicitacao',
      // orderDirection: '',
      // urlDelete: '/Pedido/Delete',
      urlEdit: '/trade/admin/pranchetas/editar/',
      urlLoad: '/Pedido/GetAssistentesAtendente/',
      // messageNextModal: 'Você tem certeza que deseja alterar o status do pedido',
      actionModal: false,
      numberRequest: [],
      statusRequest: null,
      newStatusRequest: null,
      selectedFilter: null,
      isSaving: false,
      dataFilter: {
        itens: [{ id: 0, label: 'Todos' }, { id: 1, label: 'Troca' }, { id: 2, label: 'Novo' }],
        placeholder: 'Filtrar por tipo',
      },
      id:null,
      ids:[]
    };
  }
  
  componentDidMount() {
    this.setSatus("");
  }

  setSatus = status => {
    let newStatus = {};
    switch (status) {
      case 'Pendente':
        newStatus = PREPARACAO;
        break;
      case 'Preparação':
        newStatus = PRONTAENTREGA;
        break;
      case 'Pronto para Entrega':
        newStatus = ENTREGUE;
        break;
      case 'Entregue':
        newStatus = DEVOLVIDO;
        break;
      default:
        newStatus = null;
        break;
    }

    this.setState({ newStatusRequest: newStatus });
  };

  actionNext = event => {
    this.setSatus(event.cells[6].value);
    this.setState(prevState => ({
      actionModal: !prevState.actionModal,
      selectedId: null,
      numberRequest: [event.cells[0].value],
      statusRequest: event.cells[6].value,
      id: event.id
    }));
  };

  closeModalNext = () => {
    this.setState({ actionModal: false });
  };

  updateStatus = () => {
    const { id, ids, newStatusRequest } = this.state;
    const url = `/Pedido/AtualizaStatusLote/${id || ids.join(',')}?status=${ newStatusRequest ? newStatusRequest.id : null }&retirouUniforme=&dataRetiradaUniforme=`;
    const { history } = this.props;

    this.setState({
      actionModal: false,
      isSaving: true,
    });

    pathDmService(url, {})
      .then(() => {
        this.setState({ isSaving: false });
        toast.success('Status atualizado com sucesso.');
        setTimeout(() => {
          // window.location.href = history.location.pathname;
          history.push(history.location.pathname)
        }, 1000);
        this.setState({ isSaving: false });
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar atualizar o status.');
        this.setState({ isSaving: false });
      });
  };

  
  selectedRow = obj => {
    console.log(this.state)
    const numberRequest = []
    if(obj.rows && obj.rows.length > 0) {
      this.setSatus(obj.rows[0].cells[6].value);
      this.setState({statusRequest: obj.rows[0].cells[6].value})
      obj.rows.forEach(item=> {
        numberRequest.push(item.cells[0].value);
      })
    } 
    this.setState({id:null, ids : obj.ids, numberRequest})
  }


  render() {
    const {
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      isSaving,
      actionModal,
      numberRequest,
      statusRequest,
      newStatusRequest,
      dataFilter,
      selectedFilter,
      type,
      typeCleark,
      ids
    } = this.state;

    const { defaultFilters, showCheck } = this.props;
    const rowSelect = {}
    if(showCheck) {
      rowSelect.onRowSelected= rows => {
        this.selectedRow(rows);
      };
    }

    return (
      <div className="table-uniforms">
        {showCheck && (
          <button
            disabled={!(ids && ids.length > 0)}
            className="bx--btn btn-secondary-color h-sm-margin"
            style={{marginBottom:10}}
            type="button"
            onClick={() => this.setState({actionModal:true})}
          >
            Alterar status
          </button>
        )}
        <TableDefault
          {...rowSelect}
          search={search}
          defaultFilters={defaultFilters}
          typeCleark={typeCleark}
          type={type}
          order={order}
          orderBy={orderBy}
          pageSize={pageSize}
          totalItems={totalItems}
          urlDelete={urlDelete}
          urlEdit={urlEdit}
          urlLoad={urlLoad}
          actionNext={this.actionNext}
          dataFilter={dataFilter}
          idxStatus={6}
          selectedFilter={selectedFilter}
          {...this.props}
        />

        <Modal
          open={actionModal}
          onRequestSubmit={() => this.updateStatus()}
          onRequestClose={() => this.closeModalNext()}
          modalHeading="Alteração de Status"
          primaryButtonText="Confirmar"
          secondaryButtonText="Cancelar"
        >
          <div>
            <p>
              {`Você tem certeza que deseja alterar o status ${numberRequest.length > 1 ? "dos pedidos" : "do pedido"} `}
              <strong> 
                {numberRequest.join(', ')}
              </strong>
              {' '}
de
              <strong> 
                {' '}
                {statusRequest}
                {' '}
              </strong>
              {' '}
para
              {' '}
              <strong>{newStatusRequest ? newStatusRequest.value : null}</strong>
?
            </p>
          </div>
        </Modal>
        {isSaving && <Loading small />}
      </div>
    );
  }
}
export default Items;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Clipboards/Items.js